export default "__VITE_ASSET__8f036b9d__"